import './libs/jquery-animate';
import './components/menu';

const isDesktop = window.matchMedia && window.matchMedia("(min-width: 768px)").matches;
const winHeight = $(window).height();
const paralaxControl = new ScrollMagic.Controller();

function teaserParalax() {

	var tween = TweenMax.to('#teaserBg', 1,  {
			scale: 1,
			top: [-10, 0],
			ease: Linear.easeNone
		});

	new ScrollMagic.Scene({
        triggerElement: $('body'),
        duration: winHeight,
        triggerHook: 0
      })
                  .setTween(tween)
                  // .addIndicators({name: "teaser"}) // add indicators (requires plugin)
                  .addTo(paralaxControl);


  // move content in teaser
  var teaserContent = TweenMax.to('#teaserContent', 1, {
      y: -winHeight/8,
      ease: Linear.easeNone
      ,opacity: 0
  });

  new ScrollMagic.Scene({
        triggerElement: $('body'),
        duration: winHeight/8,
        offset: winHeight/4,
        triggerHook: 0
      })
      .setTween(teaserContent)
      // .addIndicators({name: "teaserContent"}) // add indicators (requires plugin)
      .addTo(paralaxControl);


}

function menuParalax() {

  new ScrollMagic.Scene({
        triggerElement: $('body'),
        offset: winHeight/2,
        triggerHook: 0
      })
      .setClassToggle('#header', 'header--small')
      // .addIndicators({name: "header"}) // add indicators (requires plugin)
      .addTo(paralaxControl);

  var headerBg = TweenMax.to('#header', 1, {
      backgroundColor: "rgba(255,255,255,1)"
      // ,opacity: 0
  });

  new ScrollMagic.Scene({
        triggerElement: '#project',
        offset: -300,
        duration: 200,
        triggerHook: 0
      })
       .setTween(headerBg)
      // .addIndicators({name: "header-bg"}) // add indicators (requires plugin)
      .addTo(paralaxControl);


}


// projects
function projectParallax() {
  var firstGroup = function() {
    var opt = {
          triggerElement: '#project',
          offset:-100,
          duration: winHeight,
          triggerHook: 0.5
        };
    var pic1 = TweenMax
        .fromTo('#pic1', 1, {y: 200},{y: -25});

    var bg1 = TweenMax
        .fromTo('#bgWhite1', 1, {y: 100},{y: -25});

    // var text1 = TweenMax
    //     .fromTo('#text1', 1, {y: 300},{y: -75});

    new ScrollMagic.Scene(opt)
        .setTween(pic1)
        .addTo(paralaxControl);

    new ScrollMagic.Scene(opt)
        .setTween(bg1)
        .addTo(paralaxControl);

    // new ScrollMagic.Scene(opt)
    //     .setTween(text1)
    //     // .addIndicators({name: "pic1"}) // add indicators (requires plugin)
    //     .addTo(paralaxControl);
  }

  var secondGroup = function() {
    var opt = {
          triggerElement: '#project',
          offset: winHeight/2,
          duration: winHeight,
          triggerHook: 0.5
        };

    var bg2 = TweenMax
        .fromTo('#bgWhite2', 1, {y: 50},{y: -75});

    var pic2 = TweenMax
        .fromTo('#pic2', 1, {y: 200},{y: 25});


    new ScrollMagic.Scene(opt)
        .setTween(pic2)
        .addTo(paralaxControl);


    new ScrollMagic.Scene(opt)
        .setTween(bg2)
        // .addIndicators({name: "pic1"}) // add indicators (requires plugin)
        .addTo(paralaxControl);
  }


  var specialGroup = function() {
     var opt = {
      triggerElement: '#specBot',
      offset: -winHeight/2,
      duration: winHeight*2,
      triggerHook: 0.5
    };

    var bg = TweenMax
        .to('#specBg', 1, {y:200});

    var box1 = TweenMax
        .to('#box1', 1, {y:50});

    var box1 = TweenMax
        .to('#box2', 1, {y:-100});


    new ScrollMagic.Scene(opt)
        .setTween(bg)
        // .addIndicators({name: "bg"}) // add indicators (requires plugin)
        .addTo(paralaxControl);
    new ScrollMagic.Scene(opt)
        .setTween(box1)
        .addTo(paralaxControl);
    new ScrollMagic.Scene(opt)
        .setTween(box2)
        .addTo(paralaxControl);
  }


  firstGroup();
  secondGroup();
  specialGroup();
}

if($('.homepage').length) {
    
    menuParalax();
    
    if (isDesktop) {
      teaserParalax();
      projectParallax();
    }
}
else {
    $('#header').addClass('header--small');
}
